// extracted by mini-css-extract-plugin
module.exports = {"tips":"Tip__tips___1Of2d","percent":"Tip__percent___3nGMN","dollars":"Tip__dollars___3-5v7"};